import containerFuild from '../html-snippets/container-fuild';
import cssSection from '../tpl-css/style-section-card-hsia-category';

const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="card-title" data-show="true" class="card-title" style="display: block;">
      <h2 style="text-align:center;">Minimizer Bra</h2>
      <p style="text-align:center;">
        Discover our range of minimizer bras, designed to provide the perfect fit for every body.
      </p>
    </div>
    <div data-attribute="list-item" data-colperview="8" class="list-item" style="--col-perview: 8;">
      <a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10533a296e63813352037.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10537b45063b6a187e778.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1053b4dbbd3bf33a26d5d.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1053e3285fde71e26085d.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10542c42333433d5ffaa6.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10545688fb575fd80f140.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab105474b0df5cd66d3cf5f.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div> </a
      ><a data-attribute="item-category" href="#" class="item-category">
        <div class="item-category-image">
          <img
            data-attribute="image-category"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1054a51ef4019f2c994a1.png"
            alt=""
          />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>Minimizer Bra</h3>
        </div>
      </a>
    </div>
  </div>
</div>
`;
export default containerFuild(html, cssSection);
